<template>
    <div :id="id" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-sakali" role="document">
            <div class="modal-content modal-content-sakali">
                <div class="modal-header">
                    <h5 class="modal-title">{{title}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body text-center">
                    <div class="row">
                        <div class="offset-4 col-8 ps-0 text-start">
                            {{instructions}}
                        </div>
                    </div>
                    <div class="form-group row mt-2">
                        <label :for="'input-' + id" class="col-4 col-form-label text-end text-nowrap">Dein Gebot:</label>
                        <input :id="'input-' + id"
                                class="form-control form-control-sm col-6"
                               :maxlength="maxLength"
                               :type="type"
                               :placeholder="placeholder"
                               v-model="value">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
                    <button type="button" class="btn btn-sakali" @click="submit">OK</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: String,
            title: String,
            type: String,
            maxLength: Number,
            placeholder: String,
            instructions: String
        },
        data() {
            return {
                value: null,
            }
        },
        methods: {
            submit() {
                // window.$('#' + this.id).modal('dispose')
                this.$emit('submit', this.value)
            }
        }
    }
</script>

<style >
    .close {
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #FFF;
        text-shadow: 0 1px 0 #fff;
    }
</style>